import { IonIcon } from "@ionic/react";
import { flagOutline } from "ionicons/icons";
import { useState } from "react";
import CreateReportsBody from "./CreateReportsBody";

function CreateReport({ rulesType, type, objectId, nightMode }) {
  const [opened, setOpened] = useState(false);
  const [reportComplete, setReportComplete] = useState(false);

  const reportCompleted = () => {
    setReportComplete(true);
  };

  const closeReport = () => {
    setOpened(false);
  };

  if (!type || !rulesType || !objectId) {
    return (
      <p className="description">
        Error loading report system. Please contact admin@writingbattle.com
      </p>
    );
  }

  return (
    <div className="flex justify-content--end">
      {!opened && !reportComplete ? (
        <div
          className="cursor--pointer"
          onClick={(event) => {
            event.preventDefault();
            setOpened(true);
          }}
        >
          <IonIcon className="social-icon" icon={flagOutline} />
        </div>
      ) : opened && !reportComplete ? (
        <CreateReportsBody
          objectId={objectId}
          rulesType={rulesType}
          type={type}
          nightMode={nightMode}
          reportCompleted={reportCompleted}
          closeReport={closeReport}
        />
      ) : reportComplete ? (
        <p className="description bold">
          Thank you. Report submitted to our moderators.
        </p>
      ) : null}
    </div>
  );
}

export default CreateReport;
